<template>
  <el-card body-style="padding: 1em">
    <div
      @click="$emit('select', userId )"
      :class="{
        'inlin-user-card': true,
        'inlin-user-card--is-online': contact.isOnline
      }">
      <span
        class="avatar"
        :style="{ backgroundImage: 'url(&quot;' + $options.filters.defaultUserPic(contact.profilePic) + '&quot;)' }">
        <div class="online-status"></div>
      </span>

      <span class="ml-2">{{contact.displayName}}</span>
      <span v-if="!contact.isOnline">(Offline)</span>
    </div>
  </el-card>
</template>

<script>

export default {
  props: {
    userId: {
      type: String,
      required: true
    },
  },
  mounted() {
    this.$api.contact_add_if_not_cached( this.userId );
  },
  computed: {
    contact() {
      return this.$models.userContact.get_contact_by_id( this.userId ) || {
        displayName: 'loading...'
      }
    }
  },
}
</script>

<style>
.inlin-user-card--is-online .online-status {
  background: #4CAF50;
}

/*
.user-avatar.user-avatar--big {
  text-align: center;
  margin-right: 1em;
}
.user-avatar.user-avatar--small .user-avatar__text {
  margin-left: 0.2em;
}
.user-avatar.user-avatar--big .user-avatar__text {
  display: block;
  font-size: 9pt;
}
.user-avatar--small .avatar {
  width: 16px;
  height: 16px;
  border: 2px solid #cd201f;
  top: -2px;
  position: relative;
}
.user-avatar--small .online-status {
  display: none;
}

*/
</style>
